import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M0 14.058A15.014 15.014 0 1 1 14.979 30H6.875A6.884 6.884 0 0 1 0 23.125zm3.75 9.067a3.125 3.125 0 0 0 3.125 3.125h8.104a11.3 11.3 0 0 0 8.414-3.764 11.16 11.16 0 0 0 2.783-8.792 11.3 11.3 0 0 0-9.735-9.853q-.73-.09-1.466-.09c-2.62-.008-5.16.906-7.174 2.582a11.3 11.3 0 0 0-4.051 7.903z\"></path><path d=\"M18.125 13.75h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75m-8.75 2.5h8.75a1.875 1.875 0 1 1 0 3.75h-8.75a1.875 1.875 0 1 1 0-3.75\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M30 0H0v30h30z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }